import('./bootstrap')
    .catch(err => console.error(err));
import { applyPolyfills, defineCustomElements } from '@savvaslearning/cel-components/dist-stencil/loader';

void applyPolyfills().then(() => {
    void defineCustomElements(window);
});
